<template>
    <vx-card class="p-5">
      
      <!-- <h4 class="message-flags mb-0">{{ $t('CHANGE_PASSWORD').Remember_Password }}</h4>
      <p><a>{{ $t('CHANGE_PASSWORD').Click_Retrieve }}</a></p>
      <h4 class="message-flags mb-0 mt-10">
        {{ $t('CHANGE_PASSWORD').Update_Password }}
      </h4> -->
      <!-- <p class="mb-4">{{ $t('CHANGE_PASSWORD').Enter_Current_Password }}</p> -->
      
          <div class="lbl-form">{{$t('CHANGE_PASSWORD').Field_Current_Password}}</div>
          <vs-input class="w-full mb-3" :name="$t('CHANGE_PASSWORD').Field_Current_Password" 
          icon="icon icon-lock"
            icon-pack="feather"
          ref="password" v-model="form.password" v-validate="'required|min:6|max:16'" type="password"/>
          <span class="text-danger text-sm" v-show="errors.has($t('CHANGE_PASSWORD').Field_Current_Password)">{{ errors.first($t('CHANGE_PASSWORD').Field_Current_Password) }}</span>
      
          <div class="lbl-form">{{$t('CHANGE_PASSWORD').Field_New_Password}}</div>
      
          <vs-input
            :name="$t('LOGIN').Password"
            v-validate.continues="'required|min:6|max:16'"
            ref="senha"
            class="w-full mb-3"
            v-model="form.password1"
            type="password"
            icon="icon icon-lock"
            icon-pack="feather"
          />
          <span class="text-danger text-sm" v-show="errors.has($t('LOGIN').Password)">{{ errors.first($t('LOGIN').Password) }}</span>
      
          <div class="lbl-form">{{$t('CHANGE_PASSWORD').Field_New_Password_Repeat}}</div>
          <vs-input
            :name="$t('RESET_PASSWORD').Reset_Confirm"
            v-validate.continues="'required|confirmed:senha'"
            class="w-full mb-3"
            v-model="form.password2"
            type="password"
            icon="icon icon-lock"
            icon-pack="feather"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has($t('RESET_PASSWORD').Reset_Confirm)"
          >{{ errors.first($t('RESET_PASSWORD').Reset_Confirm) }}</span>
        
          <vs-checkbox v-model="form.logoutAllDevices" class="logout-all-devise mb-3">{{$t('CHANGE_PASSWORD').Quit_all_apps}}</vs-checkbox>
        
          <!-- <vs-button color="warning" type="border" class="mb-2" @click="clearForm">Limpar</vs-button> -->
          <!-- <vs-button color="primary" class="btn-save" :disabled="errors.all().length > 0" @click="onSubmit">{{$t('BUTTONS').Save}}</vs-button> -->
          <vs-button color="primary" class="btn-save" @click="onSubmit">{{$t('BUTTONS').Save}}</vs-button>
        <div v-if="!isDesktop" class="v-nav-menu-swipe-area" v-hammer:swipe.right="onClose"></div>
    </vx-card>
    
</template>

<script>
import AppConstants from "../../appConstants";
import userService from "../../providers/userService";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";
import localStorageHelper from "../../helpers/local-storage-helper";
import { EventBus } from '../../event-bus';
import messageDialogHelper from '../../helpers/message-dialog-helper';

export default {
  created() {
    EventBus.$emit(AppConstants.BUS_EVENT_HEADER_MOBILE_TITLE, this.$t('CHANGE_PASSWORD').Title);
    this.form.email = this.$store.state.AppActiveUser.email;
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
        password1: "",
        password2: "",
        logoutAllDevices: false
      }
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    },
    getTitle() {
      return this.isDesktop ? this.$t('CHANGE_PASSWORD').Title : '';
    },
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
           userService
            .changePassword(this.form, new URLSearchParams())
            .then(res => {
              localStorageHelper.updateToken(res.token);

              messageDialogHelper.displayChangePasswordSuccess(() => {
                // this.clearForm();
                if (!this.isDesktop) {
                  this.$emit('close');
                } else {
                  this.$router.push(AppConstants.NAVIGATION_PAGE_HOME);
                }
              })

              // messagesNotifyHelper.successNotify(
              //   this.$t('CHANGE_PASSWORD').Notify_Success_Title,
              //   this.$t('CHANGE_PASSWORD').Notify_Success_Message,
              // );
              
            })
            .catch(error => console.log(error));
        } 
      });
     
    },
    onCancel() {
      EventBus.$emit(AppConstants.BUS_EVENT_OPEN_USER_MENU_MOBILE);
      this.$router.push(AppConstants.NAVIGATION_PAGE_HOME);
    },
    clearForm() {
      this.form.password = null;
      this.form.password1 = null;
      this.form.password2 = null;
      setInterval(() => {
        this.errors.clear();
      }, 50);
    }
  },
  mounted() {
    EventBus.$on(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK, () => {
      this.onCancel();
    });
  },
  beforeDestroy() {
    EventBus.$off(AppConstants.BUS_EVENT_HEADER_MOBILE_BACK);
  }
};
</script>

<style>
</style>
